/**
 * Admin Check Utility
 * 
 * TEMPORARY VERSION: Uses hardcoded user ID until is_super_admin is fully configured
 * 
 * TODO: Once is_super_admin column is working in JWT tokens, switch to database check
 */

// Temporary hardcoded admin list (will be replaced with database check)
const ADMIN_USER_IDS = [
  '6321bd5e-6772-4b78-9574-48709ab2cbb8'  // Vinny's user ID
]

export const isAdmin = (user) => {
  console.log('🔍 Admin check called for user:', user?.id);
  
  if (!user) {
    console.log('❌ No user provided');
    return false;
  }
  
  // TEMPORARY: Hardcoded check
  if (ADMIN_USER_IDS.includes(user.id)) {
    console.log('✅ User is admin (hardcoded check)');
    return true;
  }
  
  // Future: Check metadata when available
  if (user.user_metadata && user.user_metadata.is_super_admin === true) {
    console.log('✅ Admin via user_metadata');
    return true;
  }
  
  if (user.app_metadata && user.app_metadata.is_super_admin === true) {
    console.log('✅ Admin via app_metadata');
    return true;
  }
  
  if (user.raw_user_meta_data && user.raw_user_meta_data.is_super_admin === true) {
    console.log('✅ Admin via raw_user_meta_data');
    return true;
  }
  
  console.log('❌ Not admin');
  return false;
}